// -----------------------------------------------------------------------------
// SCHEMA
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// Block Nodes
export const paragraph = {
    content: "inline*",
    group: "block",
    parseDOM: [{ tag: "p" }],
    toDOM() { return ["p", { class: "df-ed-cn__paragraph" }, 0]; }
};
export const blockquote = {
    content: "block+",
    group: "block",
    defining: true,
    parseDOM: [{ tag: "blockquote" }],
    toDOM() { return ["blockquote", { class: "df-ed-cn__blockquote" }, 0]; }
};
export const rule = {
    group: "block",
    parseDOM: [{ tag: "hr" }],
    toDOM() { return ["hr", { class: "df-ed-cn__rule" }]; }
};
export const h1 = {
    content: "inline*",
    group: "block",
    defining: true,
    parseDOM: [{ tag: "h1" }],
    toDOM() { return ["h1", { class: "df-ed-cn__hed1" }, 0]; }
};
export const h2 = {
    content: "inline*",
    group: "block",
    defining: true,
    parseDOM: [{ tag: "h2" }],
    toDOM() { return ["h2", { class: "df-ed-cn__hed2" }, 0]; }
};
export const h3 = {
    content: "inline*",
    group: "block",
    defining: true,
    parseDOM: [{ tag: "h3" }],
    toDOM() { return ["h3", { class: "df-ed-cn__hed3" }, 0]; }
};
export const text = {
    group: "inline"
};
export const image = {
    attrs: {
        src: {},
        id: {},
        size: {},
        alt: { default: "" },
        title: { default: "" },
        width: {},
        height: {},
        wrap: { default: true }
    },
    group: "block",
    draggable: true,
    parseDOM: [{ tag: "img[src]", getAttrs(dom) {
                return {
                    src: dom.getAttribute("src"),
                    title: dom.getAttribute("title"),
                    alt: dom.getAttribute("alt"),
                    width: dom.getAttribute("width"),
                    height: dom.getAttribute("height")
                };
            } }],
    toDOM(node) {
        let { src, alt, title, width, height, wrap } = node.attrs;
        return [
            "img", {
                src, alt, title, width, height,
                class: "df-ed-cn__image",
                style: wrap ? "display: inline-block" : "display: block"
            }
        ];
    }
};
export const hard_break = {
    inline: true,
    group: "inline",
    selectable: false,
    parseDOM: [{ tag: "br" }],
    toDOM() { return ["br"]; }
};
// Mark Nodes
export const link = {
    attrs: {
        href: {},
        title: { default: null }
    },
    inclusive: false,
    parseDOM: [{ tag: "a[href]", getAttrs(dom) {
                return {
                    href: dom.getAttribute("href"), title: dom.getAttribute("title")
                };
            } }],
    toDOM(node) {
        let { href, title } = node.attrs;
        return ["a", { href, title, class: "df-ed-cn__link" }, 0];
    }
};
export const em = {
    parseDOM: [
        { tag: "i" }, { tag: "em" },
        { style: "font-style=italic" },
        { style: "font-style=normal", clearMark: (m) => m.type.name == "em" }
    ],
    toDOM() { return ["em", 0]; }
};
export const strong = {
    parseDOM: [
        { tag: "strong" },
        { tag: "b", getAttrs: (node) => node.style.fontWeight != "normal" && null },
        { style: "font-weight=400", clearMark: (m) => m.type.name == "strong" },
        { style: "font-weight", getAttrs: (value) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null },
    ],
    toDOM() { return ["strong", 0]; }
};
